import { FareData, FareResult, FareSlab } from '../types/metro.types';

/**
 * Find the applicable fare slab for a given distance
 */
export const findFareSlab = (
  distanceKm: number,
  slabs: FareSlab[],
): FareSlab | null => {
  for (const slab of slabs) {
    if (distanceKm >= slab.minKm && distanceKm < slab.maxKm) {
      return slab;
    }
  }
  // Return last slab for distances exceeding max
  return slabs[slabs.length - 1] || null;
};

/**
 * Calculate fare for a given distance
 */
export const calculateFare = (
  distanceKm: number,
  fareData: FareData,
): FareResult => {
  const slab = findFareSlab(distanceKm, fareData.slabs);

  if (!slab) {
    // Default minimum fare if no slab found
    return {
      tokenFare: 10,
      smartCardFare: 10,
      distanceKm,
      savings: 0,
    };
  }

  return {
    tokenFare: slab.tokenFare,
    smartCardFare: slab.smartCardFare,
    distanceKm: Math.round(distanceKm * 10) / 10,
    savings: slab.tokenFare - slab.smartCardFare,
  };
};

/**
 * Format fare for display
 */
export const formatFare = (amount: number): string => {
  return `₹${amount}`;
};

/**
 * Get fare comparison text
 */
export const getFareComparison = (fareResult: FareResult): string => {
  if (fareResult.savings > 0) {
    return `Save ${formatFare(fareResult.savings)} with Smart Card!`;
  }
  return 'Same fare for token and smart card';
};
